import { MuiTableCell, MuiTableRow, styled } from '../../../../base';

export const StyledTableNewRow = styled(MuiTableRow)(({ theme }) => ({
    height: '30px !important',
    maxHeight: '30px !important',
    backgroundColor: theme.palette.action.hover,
    borderRadius: '20px',
    '& > .MuiTableCell-root': {
        padding: `${theme.spacing(0.5)} ${theme.spacing(0.75)} !important`,
        lineHeight: '1.2 !important',
        height: '30px !important',
    },
}));

export const CheckboxCell = styled(MuiTableCell)(() => ({
    width: '32px',
    padding: '0 0 0 8px !important',
    height: '30px !important',
    backgroundImage: 'none',
}));

export const FlagCell = styled(MuiTableCell)(() => ({
    width: '20px',
    padding: '0 !important',
    height: '30px !important',
    backgroundImage: 'none',
}));

export const DateCell = styled(MuiTableCell, {
    shouldForwardProp: (prop) => prop !== 'isEditMode',
})<{ isEditMode: boolean }>(({ theme: _theme, isEditMode }) => ({
    width: isEditMode ? '120px' : '90px',
    whiteSpace: 'nowrap',
    height: '30px !important',
    padding: '0 8px 0 0 !important',
    backgroundImage: 'none',

    // Overrides for small DatePicker inside DateCell
    '& .MuiInputBase-root.MuiInputBase-sizeSmall': {
        paddingRight: '0 !important',
        paddingLeft: '2px !important',
        height: '35px !important',
        boxSizing: 'border-box !important',
        display: 'flex !important',
        alignItems: 'center !important',
        marginBottom: '0 !important',
    },
    '& .MuiInputBase-input.MuiInputBase-inputSizeSmall': {
        fontSize: '0.8125rem !important',
        padding: '6px 0 6px 4px !important',
        width: '100%',
    },
    '& .MuiInputAdornment-positionEnd.MuiInputAdornment-sizeSmall': {
        margin: '0 !important',
    },
    '& .MuiInputAdornment-root .MuiSvgIcon-root': {
        fontSize: '1.1rem !important',
    },
    '& .MuiInputBase-root.MuiInputBase-sizeSmall .MuiInputAdornment-root .MuiIconButton-root.MuiInputAdornment-sizeSmall':
        {
            padding: '0px !important',
            margin: '0 0 0 2px !important',
            width: '20px !important',
            height: '20px !important',
            borderRadius: '12px !important',
            '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
            },
        },
    '& .MuiIconButton-sizeMedium': {
        margin: '0 0 0 2px !important',
        width: '25px !important',
        height: '25px !important',
    },
    '& .MuiTextField-root': {
        marginBottom: '0 !important',
        fontSize: '0.8125rem',
    },
}));

export const ActionsCell = styled(MuiTableCell)(() => ({
    width: '24px',
    padding: '0 8px 0 0 !important',
    height: '30px !important',
    backgroundImage: 'none',
}));
